import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {
  throwError as observableThrowError,
  Observable,
  of as observableOf,
} from 'rxjs';
import { ICategories } from '../interfaces/categories';
import { ISubcategories } from '../interfaces/subcategories';
import { catchError, map } from 'rxjs/operators';
import { AppSettings } from '../appSettings';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(private _apiService: ApiService) {}

  getAll(): Observable<ICategories> {
    return this._apiService.doGET('store/category').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getTree(): Observable<ICategories> {
    return this._apiService.doGET('store/tree/categories').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  storeTree(data): Observable<ICategories> {
    return this._apiService.doPOST('store/tree/categories', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  checkCategoryProduct(idcategoria: number): Observable<any> {
    return this._apiService.doGET('store/check-category/' + idcategoria).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  checkSubcategoryProduct(idsubcategoria: number): Observable<any> {
    return this._apiService
      .doGET('store/check-subcategory/' + idsubcategoria)
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  getSubcategoriesFrom(idcategoria: number): Observable<ISubcategories> {
    return this._apiService.doGET('store/category/' + idcategoria).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getUrlIconOptions(id: number) {
    return {
      url: AppSettings.API_ENDPOINT + 'store/category/' + id + '/icon',
      authTokenHeader: 'Authorization',
      authToken: 'Bearer ' + this._apiService.getAccessToken(),
    };
  }
}
